module.exports = __webpack_public_path__ + "img/cancelar-duo.42f04f13.svg";